const EXPANDED_KEY = 'couplespace:sidebar-expanded';

function readStorage(): string | null {
  if (typeof localStorage === 'undefined') {
    return null;
  }
  return localStorage.getItem(EXPANDED_KEY);
}

function writeStorage(value: string): void {
  if (typeof localStorage !== 'undefined') {
    localStorage.setItem(EXPANDED_KEY, value);
  }
}

export function getSidebarExpanded(): Record<string, boolean> {
  const raw = readStorage();
  if (!raw) {
    return {};
  }
  try {
    const parsed = JSON.parse(raw) as unknown;
    if (typeof parsed !== 'object' || parsed === null || Array.isArray(parsed)) {
      return {};
    }
    const result: Record<string, boolean> = {};
    for (const [key, value] of Object.entries(parsed)) {
      if (typeof value === 'boolean') {
        result[key] = value;
      }
    }
    return result;
  } catch {
    return {};
  }
}

export function setSidebarExpanded(expanded: Record<string, boolean>): void {
  writeStorage(JSON.stringify(expanded));
}
